import axios from "axios";
import _ from 'lodash'

axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;

axios.interceptors.request.use(async config=>{
    const app = JSON.parse(localStorage.getItem('app')) 
    if(_.get(app, 'token')) {
        config.headers.Authorization = `Bearer ${app.token}`
    } 
    return config;
})
axios.interceptors.response.use(async response => {   
    return response;
},(error)=> {
    const status = _.get(error,"response.status") || 200;
    switch(status){
        case 400: 
            return _.get(error, "response.data")?Promise.reject(error) : Promise.reject("Bad Request.") 
        case 401:           
            return _.get(error, "response.data")?Promise.reject(error) : Promise.reject("Unauthorized request.")
        case 404: 
            return _.get(error, "response.data")?Promise.reject(error) : Promise.reject("Request URL not found.")  
        case 500:           
            return _.get(error, "response.data")?Promise.reject(error) : Promise.reject("Internal Server error.")  
        default:
            break;
    }
    return Promise.reject(error);
})

const responseBody = (response) => {return response.data};

const requests = {
    get: (url, param) =>  axios.get(url, {params: param}).then(responseBody),      
    post: (url, body, param) => axios.post(url, body, {params: param}).then(responseBody),
    put: (url, body, param) => axios.put(url, body, {params:param}).then(responseBody),
    delete: (url, param) => axios.delete(url, {params: param}).then(responseBody) 
};

const Setup = {

    getBuildingById:(id)=>requests.get(`/v1/bed-management/building/${id}`, {}), 
    getIntermediateById:(type, id)=>requests.get(`v1/bed-management/inter-mediate-level/${type}/${id}`, {}),
    getBedById:(id)=>requests.get(`/v1/bed-management/bed/${id}`, {}),
    getStaff:(searchValue)=>requests.get(`/v1/bed-management/staff/search/${searchValue}`, {}),
    getInheritedStaff:(parentType, parentId)=>requests.get(`v1/bed-management/staff/inherit/${parentType}/${parentId}`, {}),

   
    saveBuilding:(data)=>requests.post('/v1/bed-management/building', data, {}),
    saveIntermediate:(data, type)=> requests.post(`v1/bed-management/inter-mediate-level/${type}`, data, {}),
    saveBed:(data)=>requests.post('/v1/bed-management/bed', data, {}),

    updateBuilding:(data)=>requests.put('/v1/bed-management/building', data, {}),
    updateIntermediate:(data, type)=> requests.put(`v1/bed-management/inter-mediate-level/${type}`, data, {}),
    updateBed:(data)=>requests.put('/v1/bed-management/bed', data, {}),

    deleteBuildingById:(id)=>requests.delete(`/v1/bed-management/building/${id}`, {}),
    deleteIntermediateById:(type, key)=>requests.delete(`v1/bed-management/inter-mediate-level/${type}/${key}`, {}),
    deleteBedById:(id)=>requests.delete(`/v1/bed-management/bed/${id}`, {}),

    duplicateBuilding:(data)=>requests.post('/v1/bed-management/building/duplicate', data, {}),
    duplicateIntermediate:(data, type)=> requests.post(`v1/bed-management/inter-mediate-level/duplicate`, data, {}),
    duplicateBed:(data)=>requests.post('/v1/bed-management/bed/duplicate', data, {}),
}
const Setting = {
    getAddBedStatus:()=> requests.get('/v1/bed-management/settings/bed/status/all', {}),
    saveBedStatus:(data)=>requests.post('/v1/bed-management/settings/bed/status', data, {}),
    updateBedStatus:(data)=>requests.put('/v1/bed-management/settings/bed/status', data, {}),

    getAddBedTypes:()=> requests.get('/v1/bed-management/settings/bed/type/all', {}),
    saveBedType:(data)=>requests.post('/v1/bed-management/settings/bed/type', data, {}),
    updateBedType:(data)=>requests.put('/v1/bed-management/settings/bed/type', data, {}),

    getAddBedTags:()=> requests.get('/v1/bed-management/settings/bed/tag/all', {}),
    saveBedTag:(data)=>requests.post('/v1/bed-management/settings/bed/tag', data, {}),
    updateBedTag:(data)=>requests.put('/v1/bed-management/settings/bed/tag', data, {}),

    getDayCodes:()=> requests.get('/v1/bed-management/refdata/attendance/daycodes/all', {}),
    getAttendanceStatus:()=> requests.get('/v1/bed-management/attendance/all', {}),
    saveAttendanceStatus:(data)=>requests.post('/v1/bed-management/attendance', data, {}),
    updateAttendanceStatus:(data)=>requests.put('/v1/bed-management/attendance', data, {}),

    getWaitlists:()=> requests.get('/v1/bed-management/settings/waitlist/all', {}),
    saveWaitlist:(data)=>requests.post('/v1/bed-management/settings/waitlist', data, {}),
    updateWaitlist:(data)=>requests.put('/v1/bed-management/settings/waitlist', data, {}),
}

const Census = {
   
    getClients:(searchValue)=>requests.get(`/v1/bed-management/client/search/${searchValue}`,{}),
    getBedAssignmentData: (assignmentId)=> requests.get(`/v1/bed-management/client-assignment/${assignmentId}`, {}),
    getActiveClientData: (clientId)=> requests.get(`/v1/bed-management/client-assignment/get-active-assignment/${clientId}`, {}),

    saveBedAssignOrReserve:(data)=>requests.post('/v1/bed-management/client-assignment', data, {}),
    updateBedAssignOrReserve:(data)=>requests.put('/v1/bed-management/client-assignment', data, {}),
    checkBedAvailability:(data)=>requests.post('/v1/bed-management/client-assignment/check-availability', data, {}),
    canRemoveAssignment:(data)=>requests.post('/v1/bed-management/client-assignment/can-remove-assignment', data, {}),
    moveClient:(data)=>requests.post('/v1/bed-management/client-assignment/move', data, {}),
    getClientDetails: (assignmentId)=> requests.get(`/v1/bed-management/history/client/assignment/${assignmentId}`, {}),
    getClientAllergy:(clientId)=> requests.get(`/v1/bed-management/client/allergies/${clientId}`, {}),
    getClientMedication:(clientId)=> requests.get(`/v1/bed-management/client/medications/${clientId}`, {}),
    getBedDetailsByIdAndDate:(id, data)=>requests.post(`/v1/bed-management/bed/${id}`, data, {}),
    getBedOccupantHistory:(id)=>requests.get(`/v1/bed-management/history/bed/${id}`, {}),
    getClientBedHistory:(id)=>requests.get(`/v1/bed-management/history/client/${id}`, {})
} 

const Attendance = {
    createClientAttendance:(attendance)=>requests.post('/v1/bed-management/attendance/client', attendance, {}),
    updateClientAttendance:(attendance)=>requests.put('/v1/bed-management/attendance/client', attendance, {})
}

const Waitlist = {
    getAllWaitlists:()=>requests.get(`v1/bed-management/waitlist-assignment/waitlist/all`, {}),
    getAllWaitlistStatuses:()=>requests.get(`/v1/bed-management/waitlist-assignment/waitlist/status/all`, {}),
    getWaitlistClients:(data)=>requests.post(`v1/bed-management/waitlist-assignment/waitlist`, data, {}),
    getWaitlistClientById:(waitlistAssignmentId)=>requests.get(`v1/bed-management/waitlist-assignment/${waitlistAssignmentId}`, {}),
    addClientToWaitlist:(data)=>requests.post(`v1/bed-management/waitlist-assignment`, data, {}),
    editWaitlistClient:(data)=>requests.put(`v1/bed-management/waitlist-assignment`, data, {}),
    removeWaitlistClient:(waitlistAssignmentId)=>requests.delete(`v1/bed-management/waitlist-assignment/${waitlistAssignmentId}`, {})
}

const Hierarchy = {
    getLocationTree: ()=> requests.get('/v1/bed-management/structure/location/all',  {}),  
    getLocationTreeById:(id)=>requests.get(`/v1/bed-management/structure/location/${id}`, {}), 
    getMultipleLocationTreeWithFilter:(filter)=>requests.post(`v1/bed-management/structure`, filter, {}),
    getLocationTreeWithFilter:(locationId, filter)=>requests.post(`/v1/bed-management/structure/location/${locationId}`, filter, {}),

}

const Location = {
    getLocations:()=> requests.get('/v1/bed-management/refdata/location/all', {}),
    getStates:()=>requests.get('/v1/bed-management/refdata/state/all', {}),
    getPrograms:()=>requests.get('/v1/bed-management/refdata/program/all', {}),
    getPrimaryLocationId: ()=>requests.get('v1/bed-management/refdata/location/staff/primary', {})

}

const Authorization = {
    getToken:(username)=>requests.get(`/v1/security/token/${username}`, {}),
}

const Services = {
    Setup,
    Setting,
    Census,
    Attendance,
    Waitlist,
    Authorization,
    Hierarchy,
    Location
}

export default Services;


